import { validateField } from '../validate-field';

const ANIMATION_WAITING_MILLISECONDS = 1200;

const setProgress = (progress) => {
  const progressBar = document.querySelector("[data-progressbar]");
  progressBar.querySelector(".progress").style.width = progress + "%";
  progressBar.querySelector(".percentage").innerText = progress + "%";

  scrollSmoothly(progressBar.parentElement);
};

const previousStep = () => {
  const $progressBar = $("[data-progressbar]");
  const step = parseInt($progressBar.data('step'))
  const steps = parseInt($progressBar.data('steps'))
  setProgress(Math.round((step - 1) / steps * 100));
};

const nextStep = () => {
  const $progressBar = $("[data-progressbar]");
  const step = parseInt($progressBar.data('step'))
  const steps = parseInt($progressBar.data('steps'))
  setProgress(Math.round((step + 1) / steps * 100));
};

const initBackLink = () => {
  $("[data-back-link]").on("click", (e) => {
    e.preventDefault();
    previousStep();
    const link = e.target.href;
    setTimeout(function () {
      window.location.href = link;
    }, ANIMATION_WAITING_MILLISECONDS);
  });
};

const autoSubmitOnSelect = (fieldIdentifier) => {
  const $form = $("[data-form]");
  const $inputField = fieldByIdOrName(fieldIdentifier);
  $inputField.on('change', () => $form.trigger('submit'));
};

const fieldByIdOrName = (fieldIdentifier) => {
  if (fieldIdentifier.startsWith('#')) {
    return $(fieldIdentifier);
  }
  return $(`input[name=${fieldIdentifier}]`);
}

const delayedSubmit = ($form, submitInterval, callback) => {
  const $inputGroups = $form.find(".input-group");
  if ($inputGroups.filter(".has-error").length > 0) {
    scrollSmoothly($(".has-error").first().parent()[0]);
    return false;
  }
  clearInterval(submitInterval);
  nextStep();
  submitInterval = setTimeout(() => {
    callback();
  }, ANIMATION_WAITING_MILLISECONDS);
};

const initFormFields = (fields, validateFields = true) => {
  const $form = $("[data-form]");
  const $inputGroups = $form.find(".input-group");

  validateFields && fields.forEach(field => validateField(field));

  let submitInterval = null;
  $form.on("submit", (event, skipProgress = false) => {
    $inputGroups.trigger("validate");
    if (!skipProgress) {
      event.preventDefault();
      return delayedSubmit($form, submitInterval, () => {
        $form.trigger("submit", [true]);
      });
    }
  });
};

/*
  The iframe is resized with "iframe-resizer" to fit the content. Thus, it is not scrollable on iOS.
  However, we can scroll on the parent window using `iframe-resizer`'s API. Since there is no support
  for smooth scrolling, we implemented a custom event.
*/
const scrollSmoothly = (element) => {
  const scrollParentIframe = () => {
    let callback = (offsetTop = 0) => {
      parentIFrame.sendMessage({type: 'smoothScrollToOffset', top: offsetTop});
      // For legacy reasons, until https://redmine.renuo.ch/issues/19293 is implemented by all clients
      element.scrollIntoView({behavior: 'smooth'});
    }
    if ('parentIFrame' in window) {
      parentIFrame.getPageInfo(({offsetTop}) => {
        callback(offsetTop + element.offsetTop);
        // getPageInfo fires on every scroll - to avoid a loop we remove the callback
        // after the first call
        callback = (offsetTop) => {
        };
      });
    }
  }

  // parentIFrame is the parentWindow, but named like that in iframe-resizer
  if ('parentIFrame' in window) {
    scrollParentIframe();
  } else {
    // For legacy reasons, until https://redmine.renuo.ch/issues/19293 is implemented by all clients
    element.scrollIntoView({behavior: 'smooth'});
  }
};

export {
  initBackLink,
  setProgress,
  autoSubmitOnSelect,
  fieldByIdOrName,
  delayedSubmit,
  initFormFields,
};
